import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{attrs:{"id":"inspire","light":""}},[_c('router-view'),_c('app-snackbar',{staticStyle:{"z-index":"9999999"},attrs:{"notification":_vm.snackbar.notification,"callback":_vm.snackbar.callback,"label":_vm.snackbar.label}}),_c('AppChat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }